// Shopify renders the email-marketing confirmation inside the theme layout,
// but its generic copy is not part of the editable theme templates/locales.
document.addEventListener('DOMContentLoaded', () => {
  const confirmation = document.querySelector('.shopify-email-marketing-confirmation__container');
  if (!confirmation) return;

  const german = document.documentElement.lang.toLowerCase().startsWith('de');
  const genericThanks = german
    ? 'Vielen Dank, dass du dich für unsere Mailingliste angemeldet hast.'
    : 'Thank you for signing up for our mailing list.';
  const genericUnsubscribe = german
    ? 'Du kannst dich jederzeit wieder abmelden.'
    : 'You can unsubscribe at any time.';
  const welcome = german ? 'Gratuliere zum 8 Hours Club.' : 'Welcome to the 8 Hours Club.';
  const textOf = (element) => element.textContent.replace(/\s+/g, ' ').trim();

  // Only change Shopify's confirmed-signup state, never a pending or error page.
  const paragraphs = [...confirmation.querySelectorAll('p')];
  const thanks = paragraphs.find((paragraph) => textOf(paragraph) === genericThanks);
  if (!thanks) return;

  const shopHeading = [...confirmation.querySelectorAll('h1, h2')]
    .find((heading) => textOf(heading) === 'Moodsup');
  if (shopHeading) {
    shopHeading.textContent = welcome;
    thanks.remove();
  } else {
    thanks.textContent = welcome;
  }

  paragraphs.find((paragraph) => textOf(paragraph) === genericUnsubscribe)?.remove();
  confirmation.classList.add('ms-club-confirmed');
  // Keep Shopify's working unsubscribe link in place.
});
